
import { SetData } from "../types";
import { PersonalPlanControls } from "./PersonalPlanControls";

interface EnhancedSetControlsProps {
  exerciseId: string;
  sets: number;
  reps: number;
  weight: number;
  setData: SetData[];
  exerciseRestTime?: number;
  setRestTime?: number;
  onUpdate: (exerciseId: string, field: string, value: number | SetData[]) => void;
  isPersonalPlan?: boolean;
}

export const EnhancedSetControls = ({
  exerciseId,
  sets,
  reps,
  weight,
  setData,
  exerciseRestTime = 60,
  setRestTime = 30,
  onUpdate,
  isPersonalPlan = false
}: EnhancedSetControlsProps) => {
  
  const handleSetsChange = (value: string) => {
    const newSets = parseInt(value);
    onUpdate(exerciseId, "sets", newSets);
  };

  const handleRepsChange = (value: string) => {
    const newReps = parseInt(value);
    onUpdate(exerciseId, "reps", newReps);
  };

  const handleWeightChange = (value: string) => {
    const newWeight = parseFloat(value) || 0;
    onUpdate(exerciseId, "weight", newWeight);
  };

  const handleExerciseRestTimeChange = (value: string) => {
    const newRestTime = parseInt(value);
    onUpdate(exerciseId, "exercise_rest_time", newRestTime);
  };

  const handleSetRestTimeChange = (value: string) => {
    const newRestTime = parseInt(value);
    onUpdate(exerciseId, "set_rest_time", newRestTime);
  };

  const handleSetDataChange = (setIndex: number, field: 'reps' | 'weight', value: string) => {
    const updatedSetData = [...setData];
    
    let numValue: number;
    if (field === 'weight') {
      numValue = value === '' ? 0 : parseFloat(value) || 0;
    } else {
      numValue = value === '' ? 0 : parseInt(value) || 0;
    }
    
    if (updatedSetData[setIndex]) {
      updatedSetData[setIndex] = {
        ...updatedSetData[setIndex],
        [field]: numValue
      };
    } else {
      updatedSetData[setIndex] = {
        reps: field === 'reps' ? numValue : reps,
        weight: field === 'weight' ? numValue : weight
      };
    }
    
    onUpdate(exerciseId, "set_data", updatedSetData);
  };

  console.log(`🎛️ Enhanced controls for ${exerciseId}:`, {
    exerciseRestTime,
    setRestTime,
    sets,
    setDataLength: setData.length,
    isPersonalPlan
  });

  // SIEMPRE usar PersonalPlanControls para edición unificada en toda la app
  console.log(`✨ Rendering unified PersonalPlanControls for exercise ${exerciseId}`);
  return (
    <PersonalPlanControls
      exerciseId={exerciseId}
      sets={sets}
      setRestTime={setRestTime}
      exerciseRestTime={exerciseRestTime}
      setData={setData}
      reps={reps}
      weight={weight}
      onSetsChange={handleSetsChange}
      onSetRestTimeChange={handleSetRestTimeChange}
      onExerciseRestTimeChange={handleExerciseRestTimeChange}
      onSetDataChange={handleSetDataChange}
    />
  );
};
